import React from 'react';
import ReactDOM from 'react-dom';

//components
import Section from './react-components/section';
import ShopProducts from './react-components/shop-products';
import ShopCategory from './react-components/shop-category';
import ShopNav from './react-components/shop-nav';
import PostsList from './react-components/posts-list';

export let Render = {


	//TO DO: refactor as one "reusableComponent" function?
	shopProducts : function() {
		let selector = '.shop-products';
		if( document.querySelector(selector) == null) return;

		//component can have multiple roots and can be rendered multiple times on a single page
		let nodes = document.querySelectorAll(selector);	
		
		nodes.forEach( node => {

			let category_id = parseInt( node.dataset.categoryId );
			let showHeader = node.dataset.showHeader == 'false' ? false : true;
			let showCta = node.dataset.showCta == 'false' ? false : true;
			let headerText = node.dataset.headerText;

			let api_url = wp_core.rest.shop_api + 'category?id=' + category_id + '&products=true';

			ReactDOM.render(
				<Section api_url={api_url}>
					<ShopProducts showHeader={showHeader} headerText={headerText} showCta={showCta} />
				</Section>, node
				);

		});		
	},

	shopCategory : function() {
		let selector = '.shop-category';
		if( document.querySelector(selector) == null) return;

		//component can have multiple roots and can be rendered multiple times on a single page
		let nodes = document.querySelectorAll(selector);
		
		nodes.forEach( node => {

			let category_id = parseInt( node.dataset.categoryId );
			let headerText = node.dataset.headerText;

			let api_url = wp_core.rest.shop_api + 'category?id=' + category_id + '&subcategories=true';

			ReactDOM.render(
				<Section api_url={api_url}>
					<ShopCategory headerText={headerText} />
				</Section>, node
				);

		});		

	},

	shopNav : function() {

		let selector = '#shop-nav';
		let api_url = wp_core.rest.shop_api + 'categories';

		ReactDOM.render(
			<Section api_url={api_url}>
				<ShopNav />
			</Section>, document.querySelector(selector)
			);

	},

	categoryPosts : function() {

		let selector = '.category-posts';
		if( document.querySelector(selector) == null) return;

		//component can have multiple roots and can be rendered multiple times on a single page
		let nodes = document.querySelectorAll(selector);
		
		nodes.forEach( node => {

			let category_id = parseInt( node.dataset.categoryId );

			let api_url = wp_core.rest.base + 'posts?categories='+ category_id +'&per_page='+5;

			ReactDOM.render(
				<Section api_url={api_url}>
					<PostsList cssClass="post-list list--recent"/>
				</Section>, node
				);

		});	

	},
	
	relatedPosts : function() {

		let selector = '#related-posts';
		if( document.querySelector(selector) == null) return;

		let node = document.querySelector(selector);

		let id_current_post = parseInt ( node.dataset.currentPostId );
		//TO DO: id_current_category
		let full = node.dataset.fullPreview == 'false' ? false : true;

		let params =  new URLSearchParams({
			'per_page' : 2,
			'exclude' : id_current_post,
		});

		let api_url = wp_core.rest.base + 'posts?' + params;

		ReactDOM.render(
			<Section api_url={api_url}>
				<PostsList full={full} cssClass="post-grid grid--related" />
			</Section>, node
			);

	}
	

}